var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrivacyTip(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1001_311462",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1001_311462)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.16732 14.167H10.834V9.16699H9.16732V14.167ZM10.0007 7.50033C10.2368 7.50033 10.4347 7.42046 10.5944 7.26074C10.7541 7.10102 10.834 6.9031 10.834 6.66699C10.834 6.43088 10.7541 6.23296 10.5944 6.07324C10.4347 5.91352 10.2368 5.83366 10.0007 5.83366C9.76454 5.83366 9.56662 5.91352 9.4069 6.07324C9.24718 6.23296 9.16732 6.43088 9.16732 6.66699C9.16732 6.9031 9.24718 7.10102 9.4069 7.26074C9.56662 7.42046 9.76454 7.50033 10.0007 7.50033ZM10.0007 18.3337C8.0701 17.8475 6.47635 16.7399 5.2194 15.0107C3.96246 13.2816 3.33398 11.3614 3.33398 9.25033V4.16699L10.0007 1.66699L16.6673 4.16699V9.25033C16.6673 11.3614 16.0388 13.2816 14.7819 15.0107C13.525 16.7399 11.9312 17.8475 10.0007 18.3337ZM10.0007 16.5837C11.4451 16.1253 12.6395 15.2087 13.584 13.8337C14.5284 12.4587 15.0007 10.9309 15.0007 9.25033V5.31283L10.0007 3.43783L5.00065 5.31283V9.25033C5.00065 10.9309 5.47287 12.4587 6.41732 13.8337C7.36176 15.2087 8.55621 16.1253 10.0007 16.5837Z",
    fill: "#603FF4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivacyTip);
export default __webpack_public_path__ + "static/media/privacy_tip.6744f966617e03119868aad4b56de1cf.svg";
export { ForwardRef as ReactComponent };